/*global angular */
/*jslint node: true */

'use strict';

var add = angular.module('add', []);
add.directive('addSlot', ['$templateCache', function ($templateCache) {
    return {
        template: $templateCache.get('slots/add/add.html')
    };
}]);
